import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_result = _resolveComponent("a-result")!

  return (_ctx.isPermission)
    ? _renderSlot(_ctx.$slots, "default", { key: 0 })
    : _renderSlot(_ctx.$slots, "otherwise", { key: 1 }, () => [
        _createVNode(_component_a_result, {
          status: "403",
          title: "403",
          "sub-title": "Sorry, you are not authorized to access this page."
        }, {
          extra: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { type: "primary" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Back Home ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
}